import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthLayoutModule } from './layouts/auth/auth-layout.module';
import { CommonLayoutModule } from './layouts/common/common-layout.module';
import { CheckErrorInterceptor } from './shared/interceptor/check-error.interceptor';
import { ChunkReloadService } from './shared/services/chunk-reload.service';
import {SharedDataStorageService} from './auth/shared/services/shared-data-storage.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function tokenGetter() {
  return localStorage.getItem('access_token');
}

function updatePaymentStatus(sharedDataStorageService: SharedDataStorageService) {
  return () => sharedDataStorageService.loadCustomerPaymentStatus();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    CommonLayoutModule,
    AuthLayoutModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter,
        allowedDomains: [environment.API_DOMAIN],
      },
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    QRCodeModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: updatePaymentStatus,
      deps: [SharedDataStorageService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CheckErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private translateService: TranslateService, chunkReload: ChunkReloadService) {
    this.translateService.setDefaultLang('en');
    chunkReload.start();
  }
}
